var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg403(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "-clip-path--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.92,330.5V311H216.24v19.5A27.88,27.88,0,0,1,210,348l-2.57,3.18h76.28L281.15,348A27.83,27.83,0,0,1,274.92,330.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "-background-simple--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.5,162s3.75-50.56-48.69-84.27-127.35-27.16-177.92-.94S124.82,162.9,108,201.29s-55.25,45-52.44,97.39,35.59,77.72,73,86.15,72.11-1.87,105.82,3.74,80.53,16.86,134.84-4.68,64.61-80.53,57.12-127.35S394.5,192.87,394.5,162Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.5,162s3.75-50.56-48.69-84.27-127.35-27.16-177.92-.94S124.82,162.9,108,201.29s-55.25,45-52.44,97.39,35.59,77.72,73,86.15,72.11-1.87,105.82,3.74,80.53,16.86,134.84-4.68,64.61-80.53,57.12-127.35S394.5,192.87,394.5,162Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "-Device--inject-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "344.1 361.12 151.32 361.12 166.54 346.43 328.88 346.43 344.1 361.12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.68,352.1c0,3-34.91,5.47-78,5.47s-78-2.45-78-5.47,34.91-5.48,78-5.48S322.68,349.07,322.68,352.1Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.68,352.1c0,3-34.91,5.47-78,5.47s-78-2.45-78-5.47,34.91-5.48,78-5.48S322.68,349.07,322.68,352.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.32,
    y: 361.12,
    width: 192.78,
    height: 13.61,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.74 389.41 137.68 389.41 151.32 374.73 344.1 374.73 357.74 389.41",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.72,
    y: 389.41,
    width: 219.98,
    height: 14.32,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "245.58 215.93 245.58 124.4 280.41 124.4 280.41 85.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.19,
    y1: 123.97,
    x2: 259.19,
    y2: 85.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "248.18 230.52 408.54 230.52 408.54 207.72 439.19 207.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "240.32 229.73 87.83 229.73 87.83 205.37 54.82 205.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "214.38 61.52 214.38 96.11 194.73 96.11 194.73 118.11 219.1 118.11 219.1 192",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "322.07 163.7 322.07 114.18 335.43 114.18 335.43 92.96 346.44 92.96",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "160.15 158.99 160.15 121.26 149.14 110.25 149.14 82.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "351.94 181 379.45 181 379.45 162.92 397.53 162.92 397.53 152.7 413.25 152.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "132.63 187.29 103.55 187.29 103.55 164.49 62.68 164.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "159.36 310.69 159.36 331.13 146 331.13 146 353.93 107.48 353.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "306.35 313.84 306.35 335.06 337 335.06 337 326.42 345.65 326.42 345.65 344.49 372.38 344.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.65,85.89a2.24,2.24,0,1,1-2.24-2.25A2.24,2.24,0,0,1,282.65,85.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.51,85.89a2.24,2.24,0,1,1-2.24-2.25A2.24,2.24,0,0,1,261.51,85.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.64,60.87a2.25,2.25,0,1,1-2.24-2.25A2.24,2.24,0,0,1,216.64,60.87Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.4,81.61a2.24,2.24,0,1,1-2.24-2.25A2.24,2.24,0,0,1,151.4,81.61Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.92,164.49a2.25,2.25,0,1,1-2.24-2.24A2.24,2.24,0,0,1,64.92,164.49Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.13,205.3a2.25,2.25,0,1,1-2.25-2.25A2.25,2.25,0,0,1,57.13,205.3Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.92,353.5a2.25,2.25,0,1,1-2.24-2.25A2.24,2.24,0,0,1,109.92,353.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.76,344.05a2.25,2.25,0,1,1-2.25-2.24A2.24,2.24,0,0,1,375.76,344.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.57,207.28a2.24,2.24,0,1,1-2.24-2.24A2.24,2.24,0,0,1,442.57,207.28Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.55,152.22a2.24,2.24,0,1,1-2.24-2.24A2.24,2.24,0,0,1,416.55,152.22Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.13,92.9a2.24,2.24,0,1,1-2.24-2.24A2.24,2.24,0,0,1,350.13,92.9Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.92,330.5V311H216.24v19.5A27.88,27.88,0,0,1,210,348l-2.57,3.18h76.28L281.15,348A27.83,27.83,0,0,1,274.92,330.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#-clip-path--inject-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.64,344.16h65.88a27.77,27.77,0,0,1-3.6-13.66V311H216.24v19.5A27.77,27.77,0,0,1,212.64,344.16Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.64,344.16h65.88a27.77,27.77,0,0,1-3.6-13.66V311H216.24v19.5A27.77,27.77,0,0,1,212.64,344.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.64,323.6h65.88a27.77,27.77,0,0,1-3.6-13.66v-19.5H216.24v19.5A27.77,27.77,0,0,1,212.64,323.6Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.92,330.5V311H216.24v19.5A27.88,27.88,0,0,1,210,348l-2.57,3.18h76.28L281.15,348A27.83,27.83,0,0,1,274.92,330.5Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.67,
    y: 143.99,
    width: 235.82,
    height: 173.15,
    rx: 8.48,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.67,290.23H363.49a0,0,0,0,1,0,0v18.43a8.48,8.48,0,0,1-8.48,8.48H136.15a8.48,8.48,0,0,1-8.48-8.48V290.23a0,0,0,0,1,0,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.53,
    y: 154.77,
    width: 212.09,
    height: 122.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.93,308a4.35,4.35,0,1,0-4.35,4.26A4.31,4.31,0,0,0,249.93,308Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.44,
    y: 351.21,
    width: 76.29,
    height: 3.48,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.9,148.42c-10.66,10-38,20-69.81,41.29,0,0,2,72,69.81,111.31Z",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.9,148.42c10.67,10,38,20,69.82,41.29,0,0-2,72-69.82,111.31Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.9,154.55C233,163.49,210.71,172,181.21,191.74c0,0,1.85,66.7,64.69,103.16,62.85-36.46,64.7-103.16,64.7-103.16C281.1,172,258.88,163.49,245.9,154.55Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.6,191.74c-29.5-19.73-51.72-28.25-64.7-37.19V294.9C308.75,258.44,310.6,191.74,310.6,191.74Z",
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.94,
    y: 227.05,
    width: 237.28,
    height: 15.36,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.61,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,131.61,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.11,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A18.37,18.37,0,0,0,129.11,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.85,229.49a1.6,1.6,0,1,1-1.6-1.56A1.58,1.58,0,0,1,137.85,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.34,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A19.51,19.51,0,0,0,135.34,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.08,229.49a1.6,1.6,0,0,1-3.19,0,1.6,1.6,0,0,1,3.19,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.57,230.35a1.28,1.28,0,0,0,.92.39,1.26,1.26,0,0,0,1.27-1.25,1.18,1.18,0,0,0-.32-.81A19.51,19.51,0,0,0,141.57,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.31,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,150.31,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.8,230.35a1.28,1.28,0,0,0,2.2-.86,1.22,1.22,0,0,0-.32-.81A18.53,18.53,0,0,0,147.8,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.54,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,156.54,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,230.35a1.29,1.29,0,0,0,.92.39,1.26,1.26,0,0,0,1.28-1.25,1.22,1.22,0,0,0-.32-.81A19.68,19.68,0,0,0,154,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.77,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,162.77,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.27,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A18.37,18.37,0,0,0,160.27,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,229.49a1.6,1.6,0,1,1-1.6-1.56A1.58,1.58,0,0,1,169,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.5,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A19.51,19.51,0,0,0,166.5,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.24,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,175.24,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.73,230.35a1.28,1.28,0,0,0,.92.39,1.26,1.26,0,0,0,1.27-1.25,1.18,1.18,0,0,0-.32-.81A19.51,19.51,0,0,0,172.73,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.47,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,181.47,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,230.35a1.28,1.28,0,0,0,2.2-.86,1.22,1.22,0,0,0-.32-.81A19.68,19.68,0,0,0,179,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,187.7,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.19,230.35a1.29,1.29,0,0,0,.92.39,1.26,1.26,0,0,0,1.28-1.25,1.22,1.22,0,0,0-.32-.81A19.68,19.68,0,0,0,185.19,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.93,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,193.93,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.43,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A19.51,19.51,0,0,0,191.43,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17,229.49a1.6,1.6,0,1,1-1.59-1.56A1.57,1.57,0,0,1,200.17,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.66,230.35a1.27,1.27,0,0,0,2.19-.86,1.18,1.18,0,0,0-.32-.81A19.51,19.51,0,0,0,197.66,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,206.4,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.89,230.35a1.28,1.28,0,0,0,2.2-.86,1.22,1.22,0,0,0-.32-.81A18.53,18.53,0,0,0,203.89,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.63,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,212.63,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.12,230.35a1.29,1.29,0,0,0,.92.39,1.26,1.26,0,0,0,1.28-1.25,1.22,1.22,0,0,0-.32-.81A19.68,19.68,0,0,0,210.12,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.61,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,131.61,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.11,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A18.37,18.37,0,0,0,129.11,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.85,239.4a1.6,1.6,0,1,1-1.6-1.55A1.58,1.58,0,0,1,137.85,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.34,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.51,19.51,0,0,0,135.34,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.08,239.4a1.6,1.6,0,1,1-1.59-1.55A1.57,1.57,0,0,1,144.08,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.57,240.27a1.27,1.27,0,0,0,2.19-.87,1.17,1.17,0,0,0-.32-.8A19.51,19.51,0,0,0,141.57,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.31,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,150.31,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.8,240.27a1.28,1.28,0,0,0,2.2-.87,1.22,1.22,0,0,0-.32-.8A18.53,18.53,0,0,0,147.8,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.54,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,156.54,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,240.27a1.29,1.29,0,0,0,.92.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.68,19.68,0,0,0,154,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.77,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,162.77,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.27,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A18.37,18.37,0,0,0,160.27,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,239.4a1.6,1.6,0,1,1-1.6-1.55A1.58,1.58,0,0,1,169,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.5,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.51,19.51,0,0,0,166.5,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.24,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,175.24,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.73,240.27a1.27,1.27,0,0,0,2.19-.87,1.17,1.17,0,0,0-.32-.8A19.51,19.51,0,0,0,172.73,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.47,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,181.47,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,240.27a1.28,1.28,0,0,0,2.2-.87,1.22,1.22,0,0,0-.32-.8A19.68,19.68,0,0,0,179,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,187.7,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.19,240.27a1.29,1.29,0,0,0,.92.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.68,19.68,0,0,0,185.19,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.93,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,193.93,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.43,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.51,19.51,0,0,0,191.43,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17,239.4a1.6,1.6,0,1,1-1.59-1.55A1.57,1.57,0,0,1,200.17,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.66,240.27a1.27,1.27,0,0,0,2.19-.87,1.17,1.17,0,0,0-.32-.8A19.51,19.51,0,0,0,197.66,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,206.4,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.89,240.27a1.28,1.28,0,0,0,2.2-.87,1.22,1.22,0,0,0-.32-.8A18.53,18.53,0,0,0,203.89,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.63,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,212.63,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.12,240.27a1.29,1.29,0,0,0,.92.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.68,19.68,0,0,0,210.12,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.68,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,281.68,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A19.51,19.51,0,0,0,279.18,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.92,229.49a1.6,1.6,0,1,1-1.59-1.56A1.57,1.57,0,0,1,287.92,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.41,230.35a1.27,1.27,0,0,0,2.19-.86,1.18,1.18,0,0,0-.32-.81A19.51,19.51,0,0,0,285.41,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.15,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,294.15,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.64,230.35a1.28,1.28,0,0,0,2.2-.86,1.22,1.22,0,0,0-.32-.81A18.53,18.53,0,0,0,291.64,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.38,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,300.38,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.87,230.35a1.29,1.29,0,0,0,.92.39,1.26,1.26,0,0,0,1.28-1.25,1.22,1.22,0,0,0-.32-.81A19.68,19.68,0,0,0,297.87,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.61,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,306.61,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.11,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A18.37,18.37,0,0,0,304.11,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.85,229.49a1.6,1.6,0,1,1-1.6-1.56A1.58,1.58,0,0,1,312.85,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.34,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A19.51,19.51,0,0,0,310.34,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.08,229.49a1.6,1.6,0,1,1-1.59-1.56A1.57,1.57,0,0,1,319.08,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.57,230.35a1.27,1.27,0,0,0,2.19-.86,1.18,1.18,0,0,0-.32-.81A19.51,19.51,0,0,0,316.57,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.31,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,325.31,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.8,230.35a1.28,1.28,0,0,0,2.2-.86,1.22,1.22,0,0,0-.32-.81A18.53,18.53,0,0,0,322.8,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.54,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,331.54,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,230.35a1.29,1.29,0,0,0,.92.39,1.26,1.26,0,0,0,1.28-1.25,1.22,1.22,0,0,0-.32-.81A19.68,19.68,0,0,0,329,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.77,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,337.77,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.27,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A18.37,18.37,0,0,0,335.27,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,229.49a1.6,1.6,0,1,1-1.6-1.56A1.58,1.58,0,0,1,344,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.5,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A19.51,19.51,0,0,0,341.5,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.24,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,350.24,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.73,230.35a1.28,1.28,0,0,0,.92.39,1.26,1.26,0,0,0,1.27-1.25,1.18,1.18,0,0,0-.32-.81A19.51,19.51,0,0,0,347.73,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.47,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,356.47,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,230.35a1.28,1.28,0,0,0,2.2-.86,1.22,1.22,0,0,0-.32-.81A19.68,19.68,0,0,0,354,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.7,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,362.7,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.19,230.35a1.29,1.29,0,0,0,.92.39,1.26,1.26,0,0,0,1.28-1.25,1.22,1.22,0,0,0-.32-.81A19.68,19.68,0,0,0,360.19,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.68,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,281.68,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.51,19.51,0,0,0,279.18,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.92,239.4a1.6,1.6,0,1,1-1.59-1.55A1.57,1.57,0,0,1,287.92,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.41,240.27a1.27,1.27,0,0,0,2.19-.87,1.17,1.17,0,0,0-.32-.8A19.51,19.51,0,0,0,285.41,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.15,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,294.15,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.64,240.27a1.28,1.28,0,0,0,2.2-.87,1.22,1.22,0,0,0-.32-.8A18.53,18.53,0,0,0,291.64,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.38,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,300.38,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.87,240.27a1.29,1.29,0,0,0,.92.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.68,19.68,0,0,0,297.87,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.61,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,306.61,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.11,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A18.37,18.37,0,0,0,304.11,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.85,239.4a1.6,1.6,0,1,1-1.6-1.55A1.58,1.58,0,0,1,312.85,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.34,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.51,19.51,0,0,0,310.34,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.08,239.4a1.6,1.6,0,1,1-1.59-1.55A1.57,1.57,0,0,1,319.08,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.57,240.27a1.27,1.27,0,0,0,2.19-.87,1.17,1.17,0,0,0-.32-.8A19.51,19.51,0,0,0,316.57,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.31,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,325.31,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.8,240.27a1.28,1.28,0,0,0,2.2-.87,1.22,1.22,0,0,0-.32-.8A18.53,18.53,0,0,0,322.8,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.54,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,331.54,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,240.27a1.29,1.29,0,0,0,.92.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.68,19.68,0,0,0,329,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.77,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,337.77,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.27,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A18.37,18.37,0,0,0,335.27,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,239.4a1.6,1.6,0,1,1-1.6-1.55A1.58,1.58,0,0,1,344,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.5,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.51,19.51,0,0,0,341.5,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.24,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,350.24,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.73,240.27a1.27,1.27,0,0,0,2.19-.87,1.17,1.17,0,0,0-.32-.8A19.51,19.51,0,0,0,347.73,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.47,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,356.47,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,240.27a1.28,1.28,0,0,0,2.2-.87,1.22,1.22,0,0,0-.32-.8A19.68,19.68,0,0,0,354,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.7,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,362.7,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.19,240.27a1.29,1.29,0,0,0,.92.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.68,19.68,0,0,0,360.19,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.41,221.8H222.2a4,4,0,0,1-4-3.92V195.64c0-15.17,12.61-27.52,28.11-27.52s28.12,12.35,28.12,27.52v22.24A4,4,0,0,1,270.41,221.8ZM226.2,214h40.2V195.64a20.1,20.1,0,0,0-40.2,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.21,
    y: 211.08,
    width: 61.38,
    height: 50.78,
    style: {
      fill: "#90CAF9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.29,232.17a6.69,6.69,0,0,0-13.37,0,6.53,6.53,0,0,0,3.51,5.76l-1.12,11.53h8.59l-1.12-11.53A6.53,6.53,0,0,0,252.29,232.17Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.75770f09072d2c114191a8eb8a202b60.svg";
export { ForwardRef as ReactComponent };